import "./CreditsPricing.scss";

import React, { FC, useContext, useState } from "react";

import { CREDITS_PRICING } from "shared/config/pricings";
import CreditsPricingCard from "features/credits/components/CreditsPricingCard";
import PageHeader from "components/PageHeader";
import ProfilCard from "components/ProfilCard/ProfilCard";
import logoIdTracker from "assets/img/ID Tracker.svg";
import { useNavigate} from "react-router-dom";
import Modal from "shared/ui/Modal";
import VideoFrame from "shared/ui/VideoFrame";
import { ReactComponent as IconFaq } from "assets/img/icons/icon_Faq.svg";
import { UserContext } from "features/account";

const iconProps = {
    fill: "#2f62ae",
    width: "20px",
};

const CreditsPricing: FC = () => {
    const { userType } = useContext(UserContext);
    const navigate = useNavigate();
    const handleNext = (planIndex: number) => {
        navigate(`${userType === 'partner' ? '/professionnels' : '/particuliers'}/payment/credits/${planIndex}/onetime`);
    };
    const [showModal, setShowModal] = useState<boolean>(false);

    return (
        <div className="CreditsPricing">
            <PageHeader
              title={"CREDIT"}
              notification={false}
              description={"plan d'achat de vérifications"}
              protectAlert={false}
            >
            </PageHeader>
            <div className="content__body">
                <ProfilCard
                    title="Facturation"
                    // Le bandeau « Facturation » répétait l'en-tête de page juste
                    // au-dessus et repoussait les offres vers le bas.
                    logo={null}>
                    <h5 className="CreditsPricing__titre">Choisissez votre pack de vérifications</h5>
                    <p className="CreditsPricing__intro">
                        Une vérification contrôle l’authenticité d’un document et signale s’il a été mis en opposition.
                        Vos vérifications restent acquises, sans date d’expiration.
                    </p>
                    <div className="row mb-1">
                        {CREDITS_PRICING.map((plan, index) => (
                            <div className="col-sm-4" key={index}>
                                <CreditsPricingCard
                                    handleNext={handleNext}
                                    plan={plan}
                                    planIndex={index}
                                    // Le meilleur tarif à l'unité, calculé et non
                                    // codé en dur : la grille peut changer.
                                    meilleureOffre={((nombre?: number) => nombre
                                        ? CREDITS_PRICING.every(
                                            (autre) => !autre.creditNumber
                                                || plan.price / nombre <= autre.price / autre.creditNumber
                                        )
                                        : false)(plan.creditNumber)}
                                />
                            </div>
                        ))}
                    </div>
                    <div className="d-flex justify-content-center align-items-center gap-05">
                        <u onClick={() => {
                            setShowModal(true);
                        }} className="pointer">en savoir plus</u>
                        <IconFaq {...iconProps} />
                    </div>
                </ProfilCard>
            </div>
            {showModal &&
                <Modal
                    onClose={() => setShowModal(false)} isOpen={showModal} title={""} infoModal={true}
                    type={"info"}>
                    <VideoFrame
                        url="https://www.youtube.com/watch?v=XvoHvSI-Huo"
                        // prevImg={ImagePrev}
                    >
                        <span className="text-primary bold">Credit de vérifcation :</span>
                        <span className="text-danger"> Découvrez l'importance de leur présence.</span>
                    </VideoFrame>
                </Modal>
            }
        </div>
    );
};
export default CreditsPricing;
